import classNames from "classnames";
import React from "react";
import { isValidNumber } from "../../utils/number-utils";
import { NOTIFICATIONS_AUTO_CLOSE_DEFAULT_DELAY } from "../constants";
import { Overlay } from "../overlay/overlay";
import { Notification } from "./notification";
import { CSS_CLASSES } from "./notifications-css-classes";
import { NotificationsProps } from "./notifications.types";

/**
 * The `Notifications` _(note the plural)_ component renders a list of floating `Notification` components as a full-screen `Overlay`.
 * It can be used to implement a page or an application level notifications display feature, where notifications appear
 * and disappear based on application logic and user interaction.
 */
export const Notifications = ({
  notifications = [],
  autoCloseDelay: autoCloseDelayProp = NOTIFICATIONS_AUTO_CLOSE_DEFAULT_DELAY,
  notificationsWidth = 320,
  notificationsMinWidth,
  notificationsMaxWidth,
  className: classNameProp,
  ...restProps
}: NotificationsProps) => {
  const className = classNames(CSS_CLASSES.NOTIFICATIONS_ROOT, classNameProp);
  return (
    <Overlay
      open={notifications.length > 0}
      showBackdrop={false}
      scrollContainer
      className={className}
      rootProps={{
        ...restProps,
        style: {
          width: notificationsWidth,
          minWidth: notificationsMinWidth,
          maxWidth: notificationsMaxWidth,
          overflow: "visible",
        },
      }}
    >
      <>
        {notifications.map(({ id, autoCloseDelay, ...notificationProps }) => {
          return (
            <Notification
              id={id}
              key={id}
              autoCloseDelay={isValidNumber(autoCloseDelay) ? autoCloseDelay : autoCloseDelayProp}
              variant="floating"
              {...notificationProps}
            />
          );
        })}
      </>
    </Overlay>
  );
};
